/**
 * Mock data for the DevPanelPreview component.
 * Each key maps to a panel name and contains the props needed to render it.
 *
 * Data shapes are verified against each panel component's prop destructuring
 * and the encounter objects generated by useEventTriggers / managers.
 */

export const PREVIEW_PANELS = {
  pirateEncounter: {
    label: 'Pirate Encounter',
    component: 'PirateEncounterPanel',
    props: {
      encounter: {
        threatLevel: 'moderate',
        description:
          'A scarred corvette drops out of warp, weapons hot. The pirate captain hails you with a sneer.',
        demandPercent: 30,
        name: 'Captain Vex',
      },
      escalated: false,
    },
  },

  combat: {
    label: 'Combat',
    component: 'CombatPanel',
    props: {
      combat: {
        intensity: 'moderate',
        description:
          'The pirate vessel opens fire. Your shields absorb the first volley, but they are closing fast.',
      },
      fleeContext: null,
    },
  },

  negotiation: {
    label: 'Negotiation',
    component: 'NegotiationPanel',
    props: {
      encounter: {
        threatLevel: 'moderate',
        description:
          'Captain Vex considers your counter-offer, fingers drumming on the console.',
        demandPercent: 30,
        name: 'Captain Vex',
      },
    },
  },

  inspection: {
    label: 'Customs Inspection',
    component: 'InspectionPanel',
    props: {
      inspection: {
        severity: 'routine',
        description:
          'An Authority patrol vessel signals you to halt for routine cargo inspection.',
      },
    },
  },

  mechanicalFailure: {
    label: 'Mechanical Failure',
    component: 'MechanicalFailurePanel',
    props: {
      failure: {
        type: 'engine_failure',
        severity: 'moderate',
      },
    },
  },

  distressCall: {
    label: 'Distress Call',
    component: 'DistressCallPanel',
    props: {
      distressCall: {
        severity: 'moderate',
        type: 'medical',
        description:
          'A civilian freighter is broadcasting an emergency beacon. Their life support is failing.',
        vesselType: 'Civilian Transport',
        crewCount: '4 persons',
        timeElapsed: '1.7 hours',
      },
    },
  },

  dangerWarning: {
    label: 'Danger Warning',
    component: 'DangerWarningDialog',
    props: {
      destinationSystemId: 5,
      destinationSystemName: 'Wolf 359',
    },
  },

  outcome: {
    label: 'Outcome',
    component: 'OutcomePanel',
    props: {
      outcome: {
        success: true,
        encounterType: 'pirate',
        choiceMade: 'return_fire',
        explanation:
          'Your weapons found their mark. The pirate vessel broke off its attack and limped away.',
        modifiers: [
          {
            name: 'Hull Integrity',
            type: 'bonus',
            value: 0.15,
            description: 'Good condition gave combat bonus',
          },
          {
            name: 'Weapons Upgrade',
            type: 'bonus',
            value: 0.1,
            description: 'Improved targeting systems',
          },
        ],
        consequences: {},
        karmaChanges: [{ amount: 2, reason: 'Self-defense against pirates' }],
        reputationChanges: [
          { faction: 'outlaws', amount: -5, reason: 'Defeated pirate crew' },
          {
            faction: 'authorities',
            amount: 3,
            reason: 'Reduced pirate activity',
          },
        ],
        resourceChanges: {
          hull: -8,
          fuel: -2,
        },
      },
    },
  },
};
